import React, { createContext, useReducer, useContext, useEffect } from "react";
import { useUserContext } from "./user_context";
import { API_BASE_URL } from "../utils/apiConfig";

const AobContext = createContext();

const initialState = {
  areasOfBusiness: [],
  isLoading: false,
  error: null,
};

function aobReducer(state, action) {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, isLoading: true, error: null };
    case "FETCH_SUCCESS":
      return { ...state, isLoading: false, areasOfBusiness: action.payload };
    case "FETCH_ERROR":
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
}

export const AobProvider = ({ children }) => {
  const { user } = useUserContext();
  const [state, dispatch] = useReducer(aobReducer, initialState);

  const loadAreasOfBusiness = async () => {
    if (!user?.results?.token) return;

    dispatch({ type: "FETCH_START" });

    try {
      const response = await fetch(`${API_BASE_URL}/aob/all`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.results.token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch areas of business.");
      }

      const data = await response.json();
      dispatch({ type: "FETCH_SUCCESS", payload: data.results || [] });
      console.log("Fetched AOB:", data.results);
    } catch (error) {
      console.error("Error fetching areas of business:", error.message);
      dispatch({ type: "FETCH_ERROR", payload: error.message });
    }
  };

  useEffect(() => {
    if (user?.results?.token) {
      loadAreasOfBusiness();
    }
  }, [user]);

  return (
    <AobContext.Provider
      value={{
        areasOfBusiness: state.areasOfBusiness,
        isLoading: state.isLoading,
        error: state.error,
        loadAreasOfBusiness,
      }}
    >
      {children}
    </AobContext.Provider>
  );
};

export const useAobContext = () => {
  return useContext(AobContext);
};
